import { FormGroup, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

export class CustomValidators {
  static MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  static PasswordValidator(
    regex: RegExp,
    error: ValidationErrors
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const valid = regex.test(control.value);

      if (control.value === '') {
        return;
      }
      return valid ? null : error;
    };
  }

  static EmailPhoneValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value === '') {
        return;
      }

      const regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      const valid = regex.test(control.value);
      if (valid) {
        return null;
      } else {
        const regex1 = new RegExp(/^(\+\d{1,3}[- ]?)?\d{10}$/);
        if (regex1.test(control.value)) {
          return null;
        } else {
          return { Error: 'Please enter valid email or mobile number' };
        }
      }
    };
  }

  static OnlyDate(date: any) {
    if (date) {
      date = moment(date).format('YYYY-MM-DD');
      return date;
    }
  }

  static OnlyTime(date: any) {
    if (date) {
      date = moment(date).format('hh:mm a');
      return date;
    }
  }

  static DateConvert(date: any) {
    if (date) {
      date = moment(date).format('MM/DD/YYYY');
      return date;
    }
  }

   static DateTimeConvert(date: any) {
    if (date) {
      date = moment(date).format('MM/DD/YYYY hh:mm a');
      return date;
    }
  }

  // static DateAndFullTimeConvert(date: any) {
  //   if (date) {
  //     date = moment(date).format('MM/DD/YYYY hh:mm:ss a');
  //     return date;
  //   }
  // }

  static ConvertToISO(date: any) {
    if (date) {
      date = moment(date).toISOString();
      return date;
    }
  }

  static utcToLocal(date: any) {
    if (date) {
      date = moment.utc(date).local().format('L');
      return date;
    }
  }

}
